import { useLocation } from "react-router-dom";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";

const NavMenuItem = ({ label, url, img, onClick, disabled, onNavigate }) => {
  const location = useLocation();
  const isMobile = useViewportBreakpoint() === "mobile";
  const class2 = location.pathname === url ? " nav-menu-item-selected" : "";

  const indicator = !isMobile ? <div className="nav-menu-indicator" /> : null;

  if (disabled)
    return (
      <div className={"nav-menu-item" + class2}>
        {indicator}
        <img src={`/images/${img}`} className="menu-img" alt="menu-img" />
        <div>{label}</div>
      </div>
    );

  if (onClick)
    return (
      <div className="nav-menu-item" onClick={onClick} style={{ cursor: "pointer" }}>
        <img src={`/images/${img}`} className="menu-img" alt="menu-img" />
        <div>{label}</div>
      </div>
    );

  return (
    <a href={url} className={"nav-menu-item" + class2} onClick={onNavigate}>
      {indicator}
      <img src={`/images/${img}`} className="menu-img" alt="menu-img" />
      <div>{label}</div>
    </a>
  );
};

export default NavMenuItem;